module.exports = __webpack_public_path__ + "static/media/unevenhip_mild_right.177029f8.png";